import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { AbstractControl, FormArray, FormControl } from '@angular/forms';

export interface DynamicListFormContext {
  index: number;
  formControl: AbstractControl;
  removeItem: () => void;
}

@Component({
  selector: 'mfp-dynamic-list',
  templateUrl: './dynamic-list.component.html',
  styleUrls: ['./dynamic-list.component.scss']
})
export class DynamicListComponent {
  @Input() name = '';
  @Input() readonly = false;
  @Input() addButtonLabel = '';
  @Input() addButtonIconPosition: 'left' | 'right' = 'left';
  @Input() addButtonIconSize: 'medium' | 'large' = 'medium';
  @Input() addButtonColor: 'primary' | 'dark' = 'primary';
  @Input() formArray: FormArray = (undefined as unknown) as FormArray;
  @ContentChild(TemplateRef)
  itemTemplateRef: TemplateRef<DynamicListFormContext> = (undefined as unknown) as TemplateRef<DynamicListFormContext>;
  @Input() createControl: () => AbstractControl = () => new FormControl({});

  get getFormControls(): AbstractControl[] {
    return this.formArray.controls as AbstractControl[];
  }

  public addItem(): void {
    this.formArray.push(this.createControl());
  }

  public removeItem(index: number): void {
    this.formArray.removeAt(index);
  }

  getFormContextAtIndex(index: number): DynamicListFormContext {
    return {
      index,
      formControl: this.getFormControls[index],
      removeItem: () => this.removeItem(index)
    };
  }
}
